<script>
    /**
     * 按钮
     */
    export default {
        name: 'normal-file-button',
        props: {
            icon: {
                default: '',
                required: false
            },
            text: {
                default: '',
                required: false
            },
            theme: {
                default: 'grey',
                required: false
            },
            marginLeft: {
                default: 0,
                required: false
            },
            marginRight: {
                default: 0,
                required: false
            },
            float: {
                default: 'left',
                required: false
            },
            disabled: {
                type: Boolean,
                default: false,
                required: false
            },
            multiple: {
                default: false,
                required: false
            },
            loading: {
                required: false,
                default: false
            },
            accept: {
                default: '',
                required: false
            },
        },
        methods: {
            change (e) {
                const fileDom = e.target;
                console.log(fileDom.files)
                this.$emit('change', fileDom.files);
                if (!this.$util.isIE()) {
                    setTimeout(() => {
                        fileDom.value = '';
                    });
                }
            }
        },
        computed: {
            curStyle () {
                return {
                    'margin-left': this.marginLeft * this.$cStyle.horizonMargin + 'px',
                    'margin-right': this.marginRight * this.$cStyle.horizonMargin + 'px',
                    'float': this.float
                };
            }
        }
    };
</script>

<template>
    <label class="button"
         :class="[theme, {disabled: disabled}]"
         :style="curStyle"
    >
        <span class="icon" :class="{loading : loading}" v-show="icon.length > 0 || loading"
              v-html="loading ? '&#xe6ac;' : icon"></span>
        <template v-if="$slots.default">
            <slot></slot>
        </template>
        <template v-else>
            <span class="text" v-show="text.length > 0" v-html="text"></span>
        </template>
        <input v-if="accept" :accept="accept" class="file-input" :disabled="disabled" type="file" :multiple="multiple" @change="change($event)">
        <input v-else class="file-input" :disabled="disabled" type="file" :multiple="multiple" @change="change($event)">
    </label>
</template>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    .button {
        box-sizing: border-box;
        border-radius: @widgetsBorderRadius;
        display: block;
        width: auto;
        min-width: 1px;
        height: @widgetsHeight;
        line-height: @widgetsHeight;
        text-align: center;
        border: 1px @otherBtnBorderNoteClr solid;
        overflow: hidden;
        padding: 0 15px;
        margin: (@lineHeight - @widgetsHeight)/2 0;
        position: relative;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        user-select: none;

        * {
            user-select: none;
        }

        &.disabled {
            background-color: @otherDisabledBgClr !important;
            color: @otherBtnBorderNoteClr !important;
            border: 1px solid @otherBorderClr !important;
            cursor: not-allowed;
        }

        > .icon {
            font-family: cmsicon;
            margin-right: 5px;
            display: inline-block;

            &.loading {
                line-height: 14px;
                height: 14px;
                width: 14px;
                transition: all 0.36s ease-in-out;
                -moz-animation: spin 2s infinite linear;
                -o-animation: spin 2s infinite linear;
                -webkit-animation: spin 2s infinite linear;
                animation: spin 2s infinite linear;

            }
        }

        > .file-input {
            cursor: pointer;
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
            bottom: 0;
            right: 0;
            /*height: 26px;*/
        }
    }

    .button, .button.grey {
        background-color: @whiteBg;
        color: @otherTextClr;

        &:hover {
            color: @primaryBg;
            border: 1px solid @primaryBg;
        }
    }

    .button.blue, .button.primary {
        border: 1px solid @primaryBg;
        background-color: @primaryBg;
        color: @whiteBg;

        &:hover {
            border: 1px solid @primaryActiveBg;
            background-color: @primaryActiveBg;
            color: @otherIptSelTipsDisbaledClr;
        }

        &.disabled {
            background-color: @primaryDisabledBg !important;
            color: @whiteBg !important;
            border: 1px solid @primaryDisabledBg !important;
            cursor: not-allowed;
        }

    }

</style>
